module.exports = "data:image/png;base64,"


//////////////////
// WEBPACK FOOTER
// ./src/plugins/app/layout/static/index/logo(1).png
// module id = Ctfj
// module chunks = 1